import { render, staticRenderFns } from "./DataUploader.vue?vue&type=template&id=4d4950a6"
import script from "./DataUploader.vue?vue&type=script&lang=js"
export * from "./DataUploader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports